import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { sources } from 'helpers/helpers';

const getTodayDate = () => {
	return new Date().toISOString().split('T')[0]; // Результат: "2026-01-21"
};

const initData = {
	items: [],
	planned_start_date: getTodayDate(),
};

function ShipmentDistributor({ modal, setModal }) {
	const { t } = useTranslation();

	const [sendData, setSendData] = useState({ ...initData });

	const [distributors, setDistributors] = useState([])
	const [fgItems, setFgItems] = useState([])

	async function create() {
		var sendDataCopy = { ...sendData }
		const response = await POST(`/sales/orders/warehouse/create-ship/`, sendDataCopy)
		if (httpOk(response)) {
			setModal(false);
			setSendData({ ...initData })
		}
	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function selectFgItem(option, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items[index].product_id = option?.product_id;
		setSendData(sendDataCopy);
	}

	function handleChangeItem(e, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items[index][e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function deleteItem(index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items.splice(index, 1)
		setSendData(sendDataCopy);
	}

	function addToList() {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items.push({

		})
		setSendData(sendDataCopy);
	}


	useEffect(() => {
		async function getDistributors() {
			const response = await GET('/sales/distributors/')
			if (httpOk(response)) {
				setDistributors(response.data)
			}
		}

		async function getFgItems() {
			const response = await GET('/inventory/fg-warehouse/items/', { size: 1000 })
			if (httpOk(response)) {
				setFgItems(response.data.results)
			}
		}

		getDistributors()
		getFgItems()
	}, []);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('distributor_shipment')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('create_shipment_document_desc')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('distributor')}</label>
						<CustomSelect
							options={distributors}
							value={distributors?.find(option => option.id === sendData?.distributor_id) || ''}
							onChange={(option) => setSendData({ ...sendData, distributor_id: option.id })}
							placeholder={t('select_distributor')}
						/>
					</div>
					<div className="form-group">
						<label>{t('order_number_optional')}</label>
						<input type="text" placeholder='SO-2025-XXXX' name="order_number"
							value={sendData.order_number} onChange={(e) => handleChange(e)} />
					</div>

					<div className="form-group">
						<label>{t('source')}</label>
						<CustomSelect
							options={sources}
							value={sources?.find(option => option.id === sendData?.source) || ''}
							onChange={(option) => setSendData({ ...sendData, source: option.id })}
							placeholder={t('select_source')}
						/>
					</div>

					<div className="card forth">
						<div className="d-between mb-16">
							<div>
								{t('items_to_ship')}
							</div>
							<button className="white small" onClick={() => addToList()}>
								<PlusIcon />
								{t('add_item')}
							</button>
						</div>

						<div className="d-flex flex-column gap-12">
							{sendData?.items?.map((item, index) => (
								<div className="d-flex gap-8" key={index}>
									<div style={{ minWidth: '200px', }}>
										<CustomSelect
											options={fgItems}
											value={fgItems?.find(option => option.id === item?.product_id) || ''}
											getOptionLabel={(option) => option.product_name}
											onChange={(option) => selectFgItem(option, index)}
											placeholder={t('sku')}
											isClearable={false}
										/>

									</div>

									<input type="text" placeholder={t('quantity')} name="quantity" className="w-100"
										value={item.quantity} onChange={(e) => handleChangeItem(e, index)} />

									<input type="text" placeholder={t('unit_price')} name="unit_price" className="w-100"
										value={item.unit_price} onChange={(e) => handleChangeItem(e, index)} />

									<button className="transparent small" style={{ height: '36px' }} onClick={() => deleteItem(index)}>
										{t('delete')}
									</button>
								</div>
							))}
						</div>
					</div>

					<div className="form-group">
						<label>{t('comment')}</label>
						<input type="text" placeholder={t('additional_info')} name="comment"
							value={sendData.comment} onChange={(e) => handleChange(e)} />
					</div>

				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={() => create()}>
						{t('ship')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default ShipmentDistributor